var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2519_105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V30H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2519_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.37207 15.116C0.37207 21.9566 5.10422 27.6898 11.4727 29.2244C11.9021 29.3278 12.3339 29.0639 12.4375 28.6345C12.541 28.205 12.2771 27.7733 11.8477 27.6697C6.18126 26.3044 1.97168 21.2005 1.97168 15.116C1.9718 7.96745 7.77016 1.97145 14.8838 1.97144C18.4595 1.97144 21.707 3.52772 24.0566 5.96851C24.3631 6.28673 24.8702 6.29638 25.1885 5.98999C25.5067 5.68358 25.5163 5.17645 25.21 4.85815C22.5886 2.13507 18.9357 0.371826 14.8838 0.371826C6.8518 0.371838 0.372186 7.1189 0.37207 15.116Z",
    fill: "#6A7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7003 1C24.7003 0.558172 25.0582 0.200195 25.5001 0.200195C25.9419 0.200195 26.2999 0.558172 26.2999 1V6C26.2999 6.38122 26.031 6.70925 25.6573 6.78418L20.6573 7.78418C20.2242 7.8708 19.8027 7.59026 19.7159 7.15723C19.6293 6.7241 19.9098 6.30264 20.3428 6.21582L24.7003 5.34375V1Z",
    fill: "#6A7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0703 15.1172C27.0703 15.9262 27.7262 16.582 28.5352 16.582C29.3442 16.582 30 15.9262 30 15.1172C30 14.3081 29.3442 13.6523 28.5352 13.6523C27.7262 13.6523 27.0703 14.3081 27.0703 15.1172Z",
    fill: "#6A7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 10.4648C26 11.2739 26.6558 11.9297 27.4648 11.9297C28.2738 11.9297 28.9297 11.2739 28.9297 10.4648C28.9297 9.65578 28.2738 9 27.4648 9C26.6558 9 26 9.65578 26 10.4648Z",
    fill: "#6A7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1914 19.8633C26.1914 20.6723 26.8472 21.3281 27.6562 21.3281C28.4653 21.3281 29.1211 20.6723 29.1211 19.8633C29.1211 19.0542 28.4653 18.3984 27.6562 18.3984C26.8472 18.3984 26.1914 19.0542 26.1914 19.8633Z",
    fill: "#6A7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6719 24.1406C23.6719 24.9497 24.3277 25.6055 25.1367 25.6055C25.9457 25.6055 26.6016 24.9497 26.6016 24.1406C26.6016 23.3316 25.9457 22.6758 25.1367 22.6758C24.3277 22.6758 23.6719 23.3316 23.6719 24.1406Z",
    fill: "#6A7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8047 27.1289C19.8047 27.938 20.4605 28.5938 21.2695 28.5938C22.0785 28.5938 22.7344 27.938 22.7344 27.1289C22.7344 26.3198 22.0785 25.6641 21.2695 25.6641C20.4605 25.6641 19.8047 26.3198 19.8047 27.1289Z",
    fill: "#6A7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9414 28.5352C14.9414 29.3442 15.5972 30 16.4062 30C17.2153 30 17.8711 29.3442 17.8711 28.5352C17.8711 27.7261 17.2153 27.0703 16.4062 27.0703C15.5972 27.0703 14.9414 27.7261 14.9414 28.5352Z",
    fill: "#6A7988"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusNew);
export default __webpack_public_path__ + "static/media/status-new.ef97530d3f0246802a1c5ecd99348646.svg";
export { ForwardRef as ReactComponent };